import {
  keysToCamelCaseDeep,
  keysToSnakeCaseDeep,
} from '@agro1desenvolvimento/utils-js';
import { APIBase } from '@agro1desenvolvimento/apis-js-package';
import { isObject } from 'lodash';
import { HttpStatusCode, isAxiosError } from 'axios';
import localStorage from './local-storage';
import AuthSession from './auth-session';
import Agro1Toast from '../components/Agro1Toast';

const REDIRECT_DELAY_MS = 2000;
class AqilaApi extends APIBase {
  private sessionExpiryHandling = false;

  constructor() {
    super();

    const baseURL = this.getBaseUrlFromStorage();

    if (!baseURL) console.error('AqilaApi: baseURL undefined');

    this.initialize({ baseURL });

    this.request.interceptors.response.use(
      (response) => {
        response.data = keysToCamelCaseDeep(response.data);

        return response;
      },
      (error) => {
        if (
          isAxiosError(error) &&
          [HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden].includes(
            error.response?.status as HttpStatusCode,
          )
        ) {
          const currentRoute = `${window.location.pathname}${window.location.search}`;
          const redirect = AuthSession.normalizeRedirect(currentRoute);
          const requestUrl = error.config?.url ?? '';
          const isLoginRequest = requestUrl.includes('v1/login');

          if (isLoginRequest) return Promise.reject(error);

          if (!this.sessionExpiryHandling) {
            this.sessionExpiryHandling = true;

            Agro1Toast.show({
              detail: 'Sessão expirada ou acesso negado. Faça login novamente.',
              severity: 'warn',
              life: 4000,
            });

            window.setTimeout(() => {
              AuthSession.expireSession(redirect);
            }, REDIRECT_DELAY_MS);
          }
        }

        return Promise.reject(error);
      },
    );

    this.request.interceptors.request.use((request) => {
      const token = localStorage.getItem('user')?.token;

      if (token) {
        request.headers.set('Authorization', `Token ${token}`);
      }

      if (isObject(request.params)) {
        request.params = keysToSnakeCaseDeep(request.params);
      }

      return request;
    });
  }

  syncBaseUrlFromStorage() {
    const baseURL = this.getBaseUrlFromStorage();
    this.request.defaults.baseURL = baseURL;
  }

  private getBaseUrlFromStorage(): string | undefined {
    return localStorage.getItem('apiHostUrl') || undefined;
  }
}

export default new AqilaApi();
